<div class="theme-container">
  <div class="theme-container-inner">
    <!-- Page Breadcrumb Start -->
    <div class="breadcrumb-main">
      <div class="breadcrumb-Skelton-section"  *ngIf="FleetList.isSkeltonSubpool">
        <div class="breadcrumb__left"> 
        <h1 class="sektion-filter"><span class="Skelton-pp"></span></h1>
        </div>
      </div>
      <snl-breadcrumb  *ngIf="!FleetList.isSkeltonSubpool">
        <div left-side> 
          <h1 *ngIf="shipFlowChart !== 'shipFlowChart_1' && shipFlowChart !== 'shipFlowChart_2' 
           && shipFlowChart !== 'shipFlowChart_3'" class="header-h1 fw-700 color__primary">{{FleetList.fleet}} Fleet management</h1>
          <span class="addShipHeader"  *ngIf="shipFlowChart === 'shipFlowChart_1' || shipFlowChart === 'shipFlowChart_2' 
           || shipFlowChart === 'shipFlowChart_3'">
           <p class="body-b1">{{FleetList.fleet}} Fleet management / Add ship </p>
            <div class="d-flex">
              <figure class="chev-icon">
                <img alt="left-icon" src="/assets/img/chevron-left.svg" (click)="goBack()">
              </figure>
              <span class="header-h1 color__primary ad-ship">Add ship</span>
            </div>
          </span>
         
        </div>         
      </snl-breadcrumb>
      <!-- <snl-breadcrumb *ngIf="!FleetList.isSkeltonSubpool">
        <div left-side class="bread-crub">
          <p class="body-b1">{{FleetList.fleet}} Fleet management / Add ship </p>
          <div class="d-flex">
            <figure class="chev-icon">
              <img alt="left-icon" src="/assets/img/chevron-left.svg" (click)="goBack()">
            </figure>
            <span class="header-h1 color__primary ad-ship">Add ship</span>
          </div> 
        </div>
      </snl-breadcrumb> -->
    </div>
    <!-- Page Breadcrumb End -->
   
    
    <!-- Container Card Start -->
    <div class="CommonContainerCard border__radius8 CommonBorderColor  mt_0 p-10 fleetListPage" *ngIf="showAllShips">
      <div class="page-tab page-tab-customize" id="subpoolSection">
        <div *ngIf="FleetList.isSkeltonSubpool" class="subpool-sektion">
          <span class="Skelton-pp"></span>
          <span class="Skelton-pp"></span>
          <span class="Skelton-pp"></span>
          <span class="Skelton-pp"></span>
          <span class="Skelton-pp"></span>
          <span class="Skelton-pp"></span>
        </div>
        <div class="subPoolsection">
          
            <snl-page-tab class="allShips" [isSelected]="selectedPagetab === 'all ships' ? true : false"
            (onPageTabClick)="clickTab('all ships')">All Ships</snl-page-tab>
            <ng-container *ngFor="let items of getPoolData">
              <ng-container>
                 <snl-page-tab class="class19"  *ngIf="items?.name === '19'"  [isSelected]="selectedPagetab === '19' ? true : false"  
                  (onPageTabClick)="clickTab('19')">
                  Pool 19
                </snl-page-tab>
                  <snl-page-tab class="class25"  *ngIf="items?.name === '25'"  [isSelected]="selectedPagetab === '25' ? true : false" 
                  (onPageTabClick)="clickTab('25')">
                    Pool 25
                </snl-page-tab>
                <snl-page-tab class="class33"  *ngIf="items?.name === '33'"  [isSelected]="selectedPagetab === '33' ? true : false"
                  (onPageTabClick)="clickTab('33')">Pool 33</snl-page-tab>
                <snl-page-tab class="class38" *ngIf="items?.name === '38'"  [isSelected]="selectedPagetab === '38' ? true : false"  
                (onPageTabClick)="clickTab('38')">
                  Pool 38
                </snl-page-tab>
                <snl-page-tab class="classCoated"  *ngIf="items?.name === 'Coated'"  [isSelected]="selectedPagetab === 'Coated' ? true : false" 
                (onPageTabClick)="clickTab('Coated')">Pool Coated</snl-page-tab>
              </ng-container>
            </ng-container>     
        </div>
        <!-- <app-sub-pool *ngIf="!FleetList.isSkeltonSubpool"  [vessels]="FleetList.vessels" [subPools]="FleetList.subPoolList" (onPageTabClick)="onPageTabClick($event)" (refreshSubpool)="refreshSubpool($event)" class=" scroll thin-scroll-x subpool-div"  ></app-sub-pool> -->
      </div>
      <div class="action-panel-main" *ngIf="!FleetList.iNotShip">
        <snl-action-panel *ngIf="!FleetList.isSkelton">
          <div left-side class="CommonFiltersPanel df-c"> 
            <div class="ResetFiltersTxt fw-700 df-c justify-content-start col-gap-16">
              <span class="color__primary section-title">Filter(s)</span>
              <a href="javascript:void(0);" class="ResetAllTxt resetAllFlTxt section-title" [ngClass]="{'active': resetActivate() == true}"  (click)="resetAll()">Reset all</a>
            </div> 
            <div class="FiltersHolder">
              <div class="dropdown-col _TextFltr _TextShipOwner " >
                <snl-dropdown [label]="'Ship owner'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
                  [options]="FleetList.shipOwners" 
                  [preSelectedItems]="shipOwners"
                  (selectedValues)="selectedValues($event,'shipOwners')"
                  (resetDropdown) ="resetDropdown($event,'shipOwners')"
                  [multiple]="true">
                </snl-dropdown>
              </div>
              <div class="dropdown-col _TextFltr _TextShip" >
                <snl-dropdown [label]="'Ship'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
                  [options]="FleetList.ship" 
                  [preSelectedItems]="shipNames"
                  (selectedValues)="selectedValues($event,'shipNames')"
                  (resetDropdown) ="resetDropdown($event,'shipNames')"
                  [multiple]="true">
                </snl-dropdown>
              </div>

               <div class="dropdown-col _TextFltr _TextShip" >
                <snl-dropdown [label]="'Status'" [buttonPrimary]="'Apply'" [buttonSecondary]="'Clear'"
                  [options]="fleetStatus" 
                  [preSelectedItems]="newfleetStatus"
                  (selectedValues)="selectedValues($event,'status')"
                  (resetDropdown) ="resetDropdown($event,'status')"
                  [multiple]="true">
                  
                </snl-dropdown>
              </div>
                     
            </div>
          </div> 
        </snl-action-panel>
        <div class="Skelton-section" *ngIf="FleetList.isSkelton">
          <div class="sektion-filter"><span class="Skelton-pp"></span></div>
          <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
          <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
          <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
          <div class="dropdown-sektion"><span class="Skelton-pp"></span></div>
        </div> 
      </div>
     
      <!-- Table Section  -->
      <div class="border__radius8 border-body-tbl CommonBorderColor table-main fleetMngTable stjs-table table-custom-2 stjs-fleet-table-overflow"> 
        <ng-container *ngIf="FleetList.vessels?.length">
          <snl-table>
            <snl-row *ngIf="!FleetList.iNotShip" class="fleetMngTableRowHeader">
              <snl-th class="ship-col">
                <span>Ship / Ship owner</span>
              </snl-th>            
              <snl-th class="pool-col-width" *ngIf="selectedPagetab === 'all ships' && (getPoolData?.length ?? 0) > 1 ">
                <span class="oneliner-width " >Pool</span>
              </snl-th>         
              <snl-th class="columntextAlign flmng-poolPonit-col">            
                <span>Pool Points</span>
              </snl-th>
              <snl-th class="flmng-status-col">
                <span>Status</span>
              </snl-th>
              <snl-th class="flmng-effDate-col">
                <span>Status effective from</span>
              </snl-th>
              <snl-th class="flmng-lastUpdated-col">
                <span>Last updated</span>
              </snl-th>
            </snl-row>
            <ng-container *ngIf="!FleetList.isSkelton && FleetList.vessels?.length">
              <snl-row class="distance-row" *ngFor="let vessel of FleetList.vessels; let i = index" >
                <snl-td class="no-checkbx ship-col">
                  <span class="CommonPillsMain color__primary section-title addColor" (click)="fetchShipdetails(vessel)">
                    {{vessel?.vslName}} 
                  </span>
                  <span class="fleetOwner body-b3">{{vessel?.vslOwner}}</span>
                </snl-td>
                <snl-td class="no-checkbx pool-col-width" textStyle="left" *ngIf="selectedPagetab === 'all ships' && (getPoolData?.length ?? 0) > 1 "><span class="color__primary">{{vessel?.subPool}}</span></snl-td>
                <snl-td class="no-checkbx colDataAlignRight flmng-poolPonit-col" textStyle="left"><span class="color__primary" *ngIf="vessel?.poolPoint">{{vessel?.poolPoint  | negativeToBracket  }}</span></snl-td>
                <snl-td class="no-checkbx flmng-status-col" textStyle="left">
                  <!-- <span class="sub-heading-s1 statusClass" *ngIf="vessel?.status"
                    [ngClass]="[vessel?.status === 'Active' ? 'activeClass' : '',vessel?.status === 'Pending' ? 'pendingClass' : '',
                    vessel?.status === 'Inactive' ? 'inActiveClass' : '']">
                    {{vessel?.status}}
                  </span> -->
                 <span class="statusClass" *ngIf="vessel?.status">
                  <snl-pills *ngIf="vessel?.status === 'Active'" [type]="'outline'" [layout]="'success' ">
                    {{vessel?.status}}
                  </snl-pills>
                  <snl-pills *ngIf="vessel?.status === 'Pending'" [type]="'outline'" [layout]="'progress' ">
                    {{vessel?.status}}
                  </snl-pills>
                  <snl-pills *ngIf="vessel?.status === 'Inactive'" [type]="'outline'" [layout]="'neutral' ">
                    {{vessel?.status}}
                  </snl-pills>
                 </span>
                </snl-td>
                <snl-td class="no-checkbx flmng-effDate-col">
                  <span class="color__primary">{{vessel?.statusEffectiveFrom ? (vessel?.statusEffectiveFrom | date:'dd MMM yyyy') : 'NA' }}</span>
                </snl-td>
                <snl-td class="no-checkbx flmng-lastUpdated-col">
                  <ng-container *ngIf="vessel?.lastUpdatedByFirstName || vessel?.lastUpdatedByUser || vessel?.updatedAt">          
                    <span class="color__primary" *ngIf="vessel?.lastUpdatedByFirstName">{{vessel?.lastUpdatedByFirstName}} {{vessel?.lastUpdatedByLastName}} ({{vessel?.lastUpdatedByInitials}})</span>
                    <span class="lastUpdateuser body-b3" *ngIf="vessel?.lastUpdatedByUser">{{vessel?.lastUpdatedByUser}}</span>
                    <span class="lastUpdatedate sub-heading-s1" *ngIf="vessel?.updatedAt">{{vessel?.updatedAt | date:'d MMMM y, H:mm' : 'UTC' }} UTC</span>
                 </ng-container>
                  <ng-container  *ngIf="!vessel?.lastUpdatedByFirstName && !vessel?.lastUpdatedByUser && !vessel?.updatedAt">
                    <span class="color__primary">NA</span>
                  </ng-container>
                </snl-td>
              </snl-row>
            </ng-container>

            <ng-container *ngIf="FleetList.isSkelton">
            <snl-row *ngFor="let number of [0,1,2,3,4,5]"> 
              <snl-td *ngIf="FleetList.tab == 'all'" class="no-checkbx"><span class="Skelton-pp"></span></snl-td>
              <snl-td class="no-checkbx"><span class="Skelton-pp"></span></snl-td>
              <snl-td class="no-checkbx"><span class="Skelton-pp"></span></snl-td>
              <snl-td class="no-checkbx"><span class="Skelton-pp"></span></snl-td>
              <snl-td class="no-checkbx"><span class="Skelton-pp"></span></snl-td>
              <snl-td class="no-checkbx"><span class="Skelton-pp"></span></snl-td> 
              <snl-td class="no-checkbx"><span class="Skelton-pp"></span></snl-td> 
            </snl-row>
            </ng-container>
            <!-- Table Data Rows End-->
          </snl-table>
        </ng-container>
        <ng-container *ngIf="FleetList.iNotShip">
          <div class="d-flex flex-column not-found">
              <div class="d-flex flex-column align-items-center justify-content-center">
                  <div class="image-area d-flex">
                    <img src="assets/img/ship-placeholder.svg" alt="img">
                  </div> 
                  <span class="sub-heading-s2 fw-700 color__secondary">You don’t have any ships yet!</span>
                  <span class="body-b1">There are no ships in the selected Sub pool yet.</span>
                 
              </div>
          </div>
        </ng-container>
      </div> 

    </div>
    <!-- Container Card End  -->
    <ng-container *ngIf="shipFlowChart === 'shipFlowChart_1' || shipFlowChart === 'shipFlowChart_2' || shipFlowChart === 'shipFlowChart_3'">
      <div class="stepper-wrapper">
        <div class="stepper">
          <div class="step stepperbasicInfo" [ngClass]="shipFlowChart === 'shipFlowChart_1' || checkedFlowchart_1 ? 'active' : ''">  
            <div class="circle" [ngClass]="checkedFlowchart_1 ? 'pr-0' : ''">
              <span *ngIf="!checkedFlowchart_1" class="sub-heading-s1">1</span>
               <figure *ngIf="checkedFlowchart_1">
                <img src="assets/img/check.svg" alt="img">
              </figure>
            </div>
            <div class="label " [ngClass]="shipFlowChart === 'shipFlowChart_1' ? 'sub-heading-s1' : 'body-b1' ">Basic Information</div>
          </div>
          <div class="step stepperPoints" [ngClass]="shipFlowChart === 'shipFlowChart_2' || checkedFlowchart_2 ? 'active' : ''">
            <div class="circle" [ngClass]="checkedFlowchart_2 ? 'pr-0' : ''">
              <span *ngIf="!checkedFlowchart_2" class="sub-heading-s1">2</span>
              <figure *ngIf="checkedFlowchart_2">
              <img src="assets/img/check.svg" alt="img">
            </figure>
            </div>
            <div class="label "  [ngClass]="shipFlowChart === 'shipFlowChart_2' ? 'sub-heading-s1' : 'body-b1' ">Points</div>
          </div>
          <div class="step stepperReview" [ngClass]="shipFlowChart === 'shipFlowChart_3' ? 'active' : ''">
            <div class="circle" >
              <span class="sub-heading-s1">3</span>
            </div>
            <div class="label" [ngClass]="shipFlowChart === 'shipFlowChart_3' ? 'sub-heading-s1' : 'body-b1' ">Review</div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="shipFlowChart === 'shipFlowChart_1' && addShipres?.length">
      <app-add-ships [shipOwnerlist]="FleetList.shipOwners" 
      [subPoolslist]="getSubpoolList"
      [addShipdata]="addShipres"
      (selected_Date)="getDateselected($event)"
      (searchVal)="getSearchval($event)"
      (shipSubpool)="getShipsubpool($event)"
      (shipOwner)="getShipowner($event)"
       ></app-add-ships>
    </ng-container>
    <ng-container *ngIf="shipFlowChart === 'shipFlowChart_2'">
      <app-add-ship-point (getPointsform)="pointsFormgroup($event)"></app-add-ship-point>
    </ng-container>
    <ng-container *ngIf="shipFlowChart === 'shipFlowChart_3'">
      <app-add-ship-review></app-add-ship-review>
    </ng-container>
  </div>
  
  <div class="BottomStickyBar footer-box-shadow">
    <div class="Skelton-section" *ngIf="FleetList.isSkelton && showAllShips">
      <div class="left-side"> 
        <div class="sektion-btm"><span class="Skelton-pp"></span></div>
        </div>
    </div>
    <snl-action-panel *ngIf="!FleetList.isSkelton" class="action-panelstyle">
      <div left-side class="df-c" *ngIf="showAllShips">
        <snl-button [size]="'small'" (buttonClick)="addShip()" class="addShipButton"> + Add Ship</snl-button>
      </div> 
      <div left-side class="df-c" *ngIf="shipFlowChart === 'shipFlowChart_1'">
        <snl-button [size]="'small'" class="flow-save-button flow_1"
         [ngClass]="!disabledBtn ? 'inValidBtn' : ''"
         (buttonClick)="saveAndnext('shipFlowChart_2')"
        [disabled]="!disabledBtn"
        ><span class="section-title">Save and next</span></snl-button>
        <span class="editConfigurationText body-b1">You can edit this configuration later</span>
        <!-- <snl-button class="flow-save-button" [size]="'small'" (buttonClick)="saveAndnext('shipFlowChart_2')"
        ><span class="section-title">Save and next</span></snl-button> -->
        <div class="cancelBtn">
        <span class="sub-heading-s1" (click)="goBack()">Cancel</span>
      </div>
      </div>
      <div left-side class="df-c" *ngIf="shipFlowChart === 'shipFlowChart_2'">
        <snl-button class="btn-prev" [size]="'small'" (buttonClick)="previous('shipFlowChart_1')">
          <span class="section-title prevBtnColor">Previous</span>
        </snl-button>
        <snl-button class="flow-save-button" [size]="'small'" [ngClass]="!pointsFormval.valid ? 'inValidBtn' : ''" (buttonClick)="saveAndnext('shipFlowChart_3')" [disabled]="!pointsFormval.valid">
          <span class="section-title">Save and next</span>
        </snl-button>
        <span class="editConfigurationText body-b1">You can edit this configuration later</span>
        <div class="cancelBtn">
        <span class="sub-heading-s1" (click)="goBack()">Cancel</span>
      </div>
      </div>
       <div left-side class="df-c" *ngIf="shipFlowChart === 'shipFlowChart_3'">
        <snl-button class="btn-prev" [size]="'small'" (buttonClick)="previous('shipFlowChart_2')">
          <span class="section-title prevBtnColor">Previous</span>
        </snl-button>
        <snl-button class="flow-submit-button" [size]="'small'" (click)="submitShip()">
          <span class="section-title" >Submit</span>
        </snl-button>
        <span class="editConfigurationText body-b1">You can edit this configuration later</span>
        <div class="cancelBtn">
          <span class="sub-heading-s1" (click)="goBack()">Cancel</span>
        </div>
      </div>
      
    </snl-action-panel>
  </div>
 
</div>

<app-add-ship *ngIf="FleetList.iNewShipForm" [iNewShipForm] ="FleetList.iNewShipForm" [subpool] ="FleetList.subPools" [tab] ="FleetList.tab"  (closeShip) = "closeShip($event)"></app-add-ship>
<!-- <app-ship-detail *ngIf="FleetList.iShipDetail" [iShipDetail] ="FleetList.iShipDetail" [vslNumber] = "FleetList.vslNumber" [owners] ="FleetList.shipOwners"  [subpool] ="FleetList.subpool"  (closeShipDetail) = "closeShipDetail($event)"></app-ship-detail> -->
<app-mark-as-status *ngIf="FleetList.iStatusForm" [iStatusForm] ="FleetList.iStatusForm" [shipDetail] = "shipDetail" (closeMarkAsStatus) = "closeMarkAsStatus($event)"></app-mark-as-status>
<app-add-edit-penalty *ngIf="FleetList.iPenaltyForm" [iPenaltyForm] ="FleetList.iPenaltyForm" [iAddPenaltyForm] ="FleetList.iAddPenaltyForm" [iEditPenaltyForm] ="FleetList.iEditPenaltyForm" [shipDetail] = "shipDetail" (closePenality) = "closePenality($event)"></app-add-edit-penalty>
<app-edit-ship-details *ngIf="FleetList.iEditShipForm" [iEditShipForm] ="FleetList.iEditShipForm" [shipDetail] = "shipDetail" [owners] ="FleetList.shipOwners"  [subpool] ="FleetList.subpool" (closeEditShip) = "closeEditShip($event)"></app-edit-ship-details>

<app-confirm-modal *ngIf="FleetList.iConfirmModal" [iConfirmModal] ="FleetList.iConfirmModal" [title]="FleetList.confirmModalTitle" [description]="FleetList.confirmModalDescription"  (onAction) = "onAction($event)"></app-confirm-modal>

<!-- <snl-modal *ngIf="FleetList.iMoveShip" class="model__customize move-ship" [settings]="FleetList.setting" (modalClose)="FleetList.iMoveShip = false" [type]="'medium'" [open]="FleetList.iMoveShip">
  <div slot="heading">Move {{filters.vslNumber.length}} Ship{{(filters.vslNumber.length>1)?'s':''}} to Sub Pool</div>
  <div slot="modalContent" style="margin-top: 24px;">
    <div class="d-flex">
        <div class="half-containers form-field">
          <form [formGroup]="moveShipForm">
            <div class="CustomizeInput dropdown-customize">
              <label class="body-b labels color__primary">Sub Pool</label>
              <ng-select class="btm-border-select" [items]="FleetList.moveSubPools" [searchable]="false" formControlName="subPool" [ngClass]="{ 'is-invalid': (moveShipForm.controls['subPool'].hasError('required')) && FleetList.moveShipSubmit}">
                  <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                      <span [innerHTML]="item"></span>
                  </ng-template>
              </ng-select>
            </div>
          </form>
        </div>
    </div>
  </div>
  
  <div slot="modalFooter">
      <snl-button size="small" (buttonClick)="moveShipToSubpool()">Save</snl-button>
      <snl-button size="small" type="secondary" (buttonClick)="closeShipToSubpool()">Cancel</snl-button>
  </div>
</snl-modal> -->




